import { Locale as i } from "../../constants/locale.js";
import { formatRelativeTime as L, formatOrdinal as y, formatRoundDays as $ } from "./helper/format.js";
import { underscoreLocale as b, hyphenLocale as a } from "./helper/locale.js";
import m from "i18next";
import I from "i18next-http-backend";
import * as t from "ramda";
import { initReactI18next as R } from "react-i18next/initReactI18next";
const E = async (d) => {
  const { buildId: f, defaultNS: s, domain: p, env: u, fallbackNS: g, ns: N, defaultLanguage: l } = d, h = {
    // debug: true,
    backend: {
      loadPath: (n, o) => {
        const r = b(t.head(n) || ""), e = t.head(o);
        return `${p}v1/${u}/json/${s}/${r}/i18n/${e}.json?buildId=${f}`;
      },
      customHeaders: () => ({ "cache-control": "no-cache" })
    },
    defaultNS: s,
    fallbackNS: g,
    fallbackLng: a(l || i.English),
    initImmediate: !1,
    interpolation: {
      escapeValue: !1,
      format: (n, o) => {
        const r = L(n, o);
        if (t.isNotNil(r))
          return r;
        const e = y(n, o);
        if (t.isNotNil(e))
          return e;
        const c = $(n, o);
        return t.isNotNil(c) ? c : n;
      }
    },
    lng: a(l || i.English),
    // ! use en-us (not en_us) to preserve plural feature in i18next
    lowerCaseLng: !0,
    ns: N,
    supportedLngs: t.map(a, t.values(i))
  };
  return await m.use(I).use(R).init(h), m;
};
export {
  E as initI18N
};
//# sourceMappingURL=index.js.map
